/* global Promise */
( function() {
	document.addEventListener( 'DOMContentLoaded', function() {
		const formEle = document.querySelector( '.js-state-region-facility' );
		if( !formEle ) { return; }

		const submitBtn = formEle.querySelector( '[type="submit"]' );
		const stateEle = formEle.querySelector( 'select[name="state"]' );
		const regionEle = formEle.querySelector( 'select[name="region"]' );

		let controller = new AbortController();
		let sendingRequest = null;
		let queuedRequest = null;

		formEle.addEventListener( 'submit', function( e ) {
			e.preventDefault();

			var goToUrl = regionEle.querySelector( 'option:checked' ).dataset.page;
			
			if( !goToUrl || !goToUrl.length ) {
				goToUrl = stateEle.querySelector( 'option:checked' ).dataset.page;
			}

			if( !goToUrl || !goToUrl.length ) {
				submitBtn.disabled = true;
			} else {
				window.location.assign( goToUrl );
			}
		} );

		stateEle.addEventListener( 'change', function() {
			const endpointParam = stateEle.value;

			// Clear out the region selector and disable it
			regionEle.value = '';
			regionEle.disabled = true;

			for( var i = regionEle.length-1; i > 0; i-- ) { // Removing all but the first child
				regionEle.removeChild( regionEle.options[i] );
			}

			if( !endpointParam || !Object.keys( endpointParam ).length ) {
				// must have a valid state selected before any navigation can occur
				submitBtn.disabled = true;
				return;
			}

			// with just a state, they are able to navigate
			submitBtn.disabled = false;

			var fetchLink = formEle.getAttribute( 'action' ) + endpointParam;

			// Stop the previous request
			if( sendingRequest ) {
				controller.abort( new DOMException( sendingRequest, 'AbortError' ) );
				queuedRequest = fetchLink;
			} else {
				getRegions( fetchLink );
			}
		} );

		function getRegions( fetchLink ) {
			controller = new AbortController(); // fresh for each request // https://stackoverflow.com/a/75175777/738394
			sendingRequest = fetchLink;
			queuedRequest = null;

			fetch( fetchLink, {
				method: formEle.getAttribute( 'method' ),
				signal: controller.signal
			} ).then( ( response, rejectResponse ) => {
				if( !response.ok ) {
					return Promise.reject( rejectResponse );
				}
				return response.json(); // Assuming the server responds with JSON
			} ).then( response => {
				if( response && response.regions && response.regions.length ) {
					response.regions.forEach( function( region ) {
						var newOption = document.createElement( 'option' );
						newOption.value = region.value;
						newOption.setAttribute( 'data-page', region.url );
						newOption.textContent = region.value;
						regionEle.appendChild( newOption );
					} );

					regionEle.value=''; // make sure it's set to the first one
					regionEle.disabled = false;
				} else {
					// eslint-disable-next-line no-console
					console.error( 'Response did not contain any regions' );
				}
			} ).catch( error => {
				if( error.name === 'AbortError' ) {
					// eslint-disable-next-line no-console
					console.warn( 'Previous request aborted', error.message );
					controller = new AbortController();
				} else {
					// eslint-disable-next-line no-console
					console.error( 'Fetch error: ', error );
				}
			} ).finally( () => {
				if( queuedRequest ) {
					// needed to wait until the resolution of the abort so it didn't abort itself
					getRegions( queuedRequest );
				} else {
					sendingRequest = null;
				}
			} );
		}
	} );
} ) ();